import { mapGetters, mapActions, mapMutations } from 'vuex'
import { updateAccountSetting } from '_api/settings';

export default {
  data() {
    return {
      _advanceLock: false,
    };
  },
  computed: {
    ...mapGetters([
      'setting_data',
    ])
  },
  methods: {
    async handleChangeAdvanceConfig(obj) {
      if (this._advanceLock) return
      this._advanceLock = true
      await this.$rtc.changeAdvanceOperate(obj)
      this._advanceLock = false
    },
    handleChangeAIDenoiser() {
      let res = this.$rtc.changeAIDenoiser(!this.setting_data.AI_denoiser_V2)
      if (!res) {
        this.SET_SETTING_DATA_PARAM({
          AI_denoiser_V2: false,
        })
        this.$toast.error('您的浏览器不支持AI降噪，请升级或更换浏览器')
      }
    },
    changeAIDenoiserVersion(v) {
      this.SET_USER_ACCOUNT_SETTINGS({
        trtc_ai_denoise_version: v
      })
      updateAccountSetting({}, {
        setting: 'trtc_ai_denoise_version',
        value: v
      })
      this.$rtc.RtcApi?.changeAIDenoiserVersion && this.$rtc.RtcApi?.changeAIDenoiserVersion(v)
    },
    changeAIDenoiserType(v) {
      this.SET_USER_ACCOUNT_SETTINGS({
        trtc_ai_denoise_type: v
      })
      updateAccountSetting({}, {
        setting: 'trtc_ai_denoise_type',
        value: v
      })
      this.$rtc.RtcApi?.changeAIDenoiserType && this.$rtc.RtcApi?.changeAIDenoiserType(v)
    },
    ...mapActions([
      'SET_SETTING_DATA_PARAM',
      'SET_USER_ACCOUNT_SETTINGS',
    ]),
  }
};
